<template>
    <b-container class="breadcrumb-container">
        <b-breadcrumb>
            <b-breadcrumb-item
                v-for="(breadcrumb, index) in this.breadcrumbs"
                href="#"
                v-bind:key="index"
                v-bind:disabled="breadcrumb.disabled"
                v-bind:active="breadcrumb.active"
                @click.stop="handleRouting(breadcrumb)">
                {{breadcrumb.translate ? $t(breadcrumb.text) : breadcrumb.text}}
            </b-breadcrumb-item>
        </b-breadcrumb>
    </b-container>
</template>

<script>
export default {
name: "BreadCrumbs",
    props: {
        breadcrumbs: {
            type: Array,
            default() {
                return []
            }
        },
    },
    methods: {
        handleRouting: function (breadcrumb) {
            if (breadcrumb.active) {
                return
            }
            let params = breadcrumb.params ? breadcrumb.params : {}
            this.$router.push({name: breadcrumb.route, params })
        }
    }
}
</script>

<style scoped>

</style>